import { Snackbar } from "@material-ui/core";

import { getAllRealWarehouses, getAllWarehousesManager } from "../../reduxSaga/actions";
import { useSelector, useDispatch } from "react-redux";

import { useEffect, useState } from "react";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { Alert } from "@material-ui/lab";
import WarehouseService from "../../services/WarehouseService";
import { useNavigate } from "react-router-dom";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import CashRegisterService from "../../services/ProductSellBToC/CashRegisterService";
import BanqueService from "../../services/Banque";

const AddShop = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const warehousesManager = useSelector(
    (state) => state.staff.warehousesManager.success
  );


  const styles = {
    container: (base) => ({
      ...base,
      flex: 1,
    }),
  };
  const [name, setName] = useState("");
  const [lat, setLat] = useState("");
  const [len, setLen] = useState("");

  const [address, setAddress] = useState("");

  const animatedComponents = makeAnimated();
  const [desc, setDesc] = useState("");
  const [selectedOption, setSelectedOption] = useState(null);
  const [options, setOptions] = useState([]);

  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();
  const [isCancel, setIsCancel] = useState(false);
  const [selectedOptionWarehouseManager, setSelectedOptionWarehouseManager] =
    useState(null);
  const [selectedOptionCashRegister, setSelectedOptionCashRegister] =
    useState(null);
  const [selectedOptionWarehouse, setSelectedOptionWarehouse] = useState(null);
  const [warehouseManagerId, setWarehouseManagerId] = useState([]);
  const [allManagers, setAllManagers] = useState([]);
  const [listManagersId, setListManagersId] = useState([]);

  const [allWarehouses, setAllWarehouses] = useState([]);
  const [listWarehousesId, setListWarehousesId] = useState([]);
  const [allCashRegister, setAllCashRegister] = useState([]);
  const [listCashRegisterId, setListCashRegisterId] = useState([]);

  const[idBankAccount,setIdBankAccount]=useState();
  // const [banquesAccount, setBanquesAccount] = useState([]);
  const [
    warehouseManagerSelectPlaceHolder,
    setWarehouseManagerSelectPlaceHolder,
  ] = useState("Choisir un manager");
  const [
    bankAccountSelectPlaceHolder,
    setBankAccountSelectPlaceHolder,
  ] = useState("Choisir un compte bancaire");
  const [warehouseSelectPlaceHolder, setWarehouseSelectPlaceHolder] =
    useState("Choisir un dépôt");
  const [cashRegisterSelectPlaceHolder, setCashRegisterSelectPlaceHolder] =
    useState("Choisir une caisse");
    const [warehousesSource, setWarehousesSource] = useState([]);
    const [warehouseSourceId, setWarehouseSourceId] = useState(0);
    const [allWarehouseSource, setAllWarehouseSource] = useState([]);
    const [warehouseSelectedOption, setWarehouseSelectedOption] = useState(null);


  useEffect(() => {
    dispatch(getAllWarehousesManager());
    WarehouseService.getAllRealWarehouse(getCurrentUserId(), 0)
    .then((response) => {
      console.log("response", response);
      if (response.data.success) {
        setWarehousesSource(response.data.success);
      } else {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : pas de dépôt");
      }
    })
    .catch((e) => {
      console.log("error in getAllRealWarehouse", e);
    });
    CashRegisterService.getAllWarehousesNotInShop(getCurrentUserId()).then(
      (response) => {
        response.data.success.map((wh, i) => {
          setAllWarehouses((oldArray) => [
            ...oldArray,
            {
              value: wh.id,
              label: wh.ref + "-" + wh.name,
            },
          ]);
        });
      }
    );
    setAllCashRegister([])
    CashRegisterService.getAllCashRegisterInShop(getCurrentUserId(), 0)
      .then((response) => {
        if (response.data.success) {
          response.data.success.map((wh, i) => {
            setAllCashRegister((oldArray) => [
              ...oldArray,
              {
                value: wh.id,
                label: wh.reference,
              },
            ]);
          });
        } else {
          console.log("error in getAllCashRegister", response.data.success);
        }
      })
      .catch((e) => {
        console.log("error in getAllCashRegister", e);
      });

    BanqueService.getAllBankAccounts(1)
      .then((response) => {
        if (response.data["Banque"]) {
        } else {
          // setBanquesAccount(response.data["success"])

          response.data["success"].map((BA) => {
            setOptions((oldArray) => [
              ...oldArray,
              {
                value: BA.idBankAccount,
                label: BA.rib + "-" + BA.name + "-" + BA.agenceLocalisation,
              },
            ])
          })
        }
      })
      .catch((error) => {
        this.setState({ alert_message: "error" });

        this.setState({ alert_message: "success" });
      });
  }, []);

  useEffect(() => {
    warehousesSource &&
      warehousesSource.map((element) => {
        let exist = false;
        if (allWarehouseSource.length !== 0) {
          for (let index = 0; index < allWarehouseSource.length; index++) {
            if (allWarehouseSource[index].value === element?.id) {
              exist = true;
              break;
            }
          }
        }
        if (element?.id !== undefined && exist === false) {
          setAllWarehouseSource((oldArray) => [
            ...oldArray,
            { value: element.id, label: element.name },
          ]);
        }
        //here
      });
  }, [warehousesSource]);

  useEffect(() => {
    setAllManagers([]);

    warehousesManager &&
      warehousesManager.map((element, i) => {
        if (i === 0) {
          setWarehouseManagerId(element.id);
        }
        setAllManagers((oldArray) => [
          ...oldArray,
          {
            value: element.id,
            label: element.firstName + " " + element.lastName,
          },
        ]);
      });
  }, [warehousesManager]);

  const onChangeNameHandler = (event) => {
    setName(event.target.value);
  };


  const onChangeLatHandler = (event) => {
    setLat(event.target.value);
  };
  const onChangeLenHandler = (event) => {
    setLen(event.target.value);
  };
  const onChangeAddressHandler = (event) => {
    setAddress(event.target.value);
  };

  const onChangeDescriptionHandler = (event) => {
    setDesc(event.target.value);
  };

  const onValidWarehouseHandler = () => {
    if (name === "") {
      setErrorAlertText("Erreur :le champ du nom est vide ! ");
      setOpenErrorAlert(true);
    } else if (listManagersId.length === 0) {
      setErrorAlertText("Erreur :le responsable est vide ! ");
      setOpenErrorAlert(true);
    } else if (warehouseSourceId === null) {
      setErrorAlertText("Erreur :le dépôt est vide ! ");
      setOpenErrorAlert(true);
    } else if (listCashRegisterId.length === 0) {
      setErrorAlertText("Erreur :la caisse est vide ! ");
      setOpenErrorAlert(true);
    } else if (address === 0) {
      setErrorAlertText("Erreur :l'adresse est vide ! ");
      setOpenErrorAlert(true);
    } else {
      let listManagers = [];
      listManagersId &&
        listManagersId.map((element, i) => {
          listManagers.push(element.value);
        });
      let listCashRegister = [];
      listCashRegisterId &&
        listCashRegisterId.map((element, i) => {
          listCashRegister.push(element.value);
        });
      let listWarehouses = [];
      listWarehouses.push(warehouseSourceId);

     

      let AddShopModel = {
        name: name,
        listManagers: listManagers,
        idUser: getCurrentUserId(),
        listCashRegisters: listCashRegister,
        listWarehouses: listWarehouses,
        description: desc,
        idBankAccount:idBankAccount,
        address: address,
        len: len,
        lat: lat,
      };
      CashRegisterService.addShop(AddShopModel)
        .then((response) => {
          if (response.data["success"]) {
            setOpenSuccessAlert(true);
            setSuccessAlertText("Enregistrement avec succées");
            setTimeout(() => {
              navigate(`/magasins`);
            }, 2000);
          } else {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur :erreur serveur ");
          }
        })
        .catch((e) => {
          console.log("error", e);
        });
    }
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };
  const onChangeSelectedWarehouseManager = (selectedOption) => {
    setSelectedOptionWarehouseManager();
    setListManagersId(selectedOption);
  };

  const onChangeSelectedCashRegister = (selectedOption) => {
    setSelectedOptionCashRegister();
    setListCashRegisterId(selectedOption);
  };
  const onChangeSelectedWarehouse = (selectedOptionn) => {
    setSelectedOption();
    setWarehouseSourceId(selectedOptionn.value);
    setWarehouseSelectPlaceHolder(selectedOptionn.label);
  };
  const handleChange = (selectedOption) => {
    setIdBankAccount(selectedOption.value);
    setBankAccountSelectPlaceHolder(selectedOption.label);
  };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6"></div>
            <div className="col-md-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item">Home</li>
                <li class="breadcrumb-item active">Ajouter Magasin</li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className="content ">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card card-dark">
                <div className="card-header">
                  <h5 className="card-title"> Ajouter un magasin</h5>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-4">
                      <div className="form-group">
                        <label htmlFor="inputName">Libellé</label>
                        <input
                          placeholder="Ajouter libellé "
                          onChange={onChangeNameHandler}
                          type="text"
                          id="inputName"
                          className="form-control"
                        />
                      </div>
                    </div>

                    <div className="col-sm-4">
                      <div className="form-group">
                        <label htmlFor="inputName">Lattitude</label>
                        <input
                          placeholder="Ajouter libellé "
                          onChange={onChangeLatHandler}
                          type="text"
                          id="inputName"
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div className="form-group">
                        <label htmlFor="inputName">longitude</label>
                        <input
                          placeholder="Ajouter réference "
                          onChange={onChangeLenHandler}
                          type="text"
                          id="inputName"
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <label htmlFor="inputName">Adresse</label>
                        <input
                          placeholder="Ajouter adresse "
                          onChange={onChangeAddressHandler}
                          type="text"
                          id="inputName"
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <label>Choisir le responsable du magasin</label>

                        <Select
                          styles={styles}
                          isMulti
                          closeMenuOnSelect={true}
                          components={animatedComponents}
                          defaultValue={selectedOptionWarehouseManager}
                          onChange={onChangeSelectedWarehouseManager}
                          options={allManagers}
                          placeholder={warehouseManagerSelectPlaceHolder}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <label>Choisir le compte bancaire</label>
                        <Select
                          value={selectedOption}
                          closeMenuOnSelect={true}
                          components={animatedComponents}
                          options={options}
                          onChange={handleChange}
                          defaultValue={selectedOption}
                          placeholder={bankAccountSelectPlaceHolder}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <label>Choisir les dépôts</label>

                        <Select
                          closeMenuOnSelect={true}
                          components={animatedComponents}
                          defaultValue={warehouseSelectedOption}
                          onChange={onChangeSelectedWarehouse}
                          options={allWarehouseSource}
                          placeholder={warehouseSelectPlaceHolder}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <label>Choisir les caisses</label>

                        <Select
                          styles={styles}
                          isMulti
                          closeMenuOnSelect={true}
                          components={animatedComponents}
                          defaultValue={selectedOptionCashRegister}
                          onChange={onChangeSelectedCashRegister}
                          options={allCashRegister}
                          placeholder={cashRegisterSelectPlaceHolder}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <label htmlFor="inputDescription">Description</label>
                        <textarea
                          placeholder="Saisir..."
                          onChange={onChangeDescriptionHandler}
                          id="inputDescription"
                          className="form-control"
                          rows={2}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-footer" style={{ marginTop: "1%" }}>
                  <button
                    class="btn btn-dark float-right"
                    style={{ marginTop: "1%" }}
                    onClick={onValidWarehouseHandler}
                  >
                    Confirmer
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default AddShop;
